import { render } from "./CreateCita.vue?vue&type=template&id=263ea186&scoped=true"
import script from "./CreateCita.vue?vue&type=script&lang=js"
export * from "./CreateCita.vue?vue&type=script&lang=js"

import "./CreateCita.vue?vue&type=style&index=0&id=263ea186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263ea186"]])

export default __exports__